import request from '@/utils/request'

//志愿者申请
export function listActivateVipType(data) {
  return request({
    url: '/api/visitor/vip/activateVipType',
    method: 'post',
    data
  });
}
//获取志愿者招募发布列表--可分页
export function listVipType(params) {
  return request({
    url: '/api/visitor/listVipType',
    method: 'get',
    params
  });
}

// 获取个人信息
export function visitorInfo(params) {
  return request({
    url: '/api/visitor/info',
    method: 'get',
    params
  });
}

// 上传身份图片
export function uploadFeatureImg(data) {
  return request({
    url: '/api/visitor/feature',
    method: 'post',
    data
  });
}

// 提交注册
export function confirmOrder(data) {
  return request({
    url: '/api/visitor/confirmOrder',
    method: 'post',
    data
  });
}

// 获取订单号
export function submitOrder(data) {
  return request({
    url: '/api/visitor/submitOrder',
    method: 'post',
    data,
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    }
  });
}

// 获取支付码
export function wxJsApiPay(data) {
  return request({
    url: '/api/pay/wxNativePay',
    method: 'post',
    data
  });
}

// 查询支付单信息
export function queryPayOrder(data) {
  return request({
    url: '/api/pay/queryPayOrder',
    method: 'post',
    data
  });
}

// 获取商城列表
export function pageVipGoods(params) {
  return request({
    url: '/api/visitor/pageVipGoods',
    method: 'get',
    params
  });
}

// 获取我的福利列表
export function myWelfare(data) {
  return request({
    url: '/api/visitor/vip/myWelfare',
    method: 'post',
    data
  });
}

// 获取我的订单列表
export function myVipOrder(data) {
  return request({
    url: '/api/visitor/vip/myVipOrder',
    method: 'post',
    data
  });
}

// 获取订单详情
export function getVipTypeByOrderNum(data) {
  return request({
    url: '/api/visitor/vip/getVipTypeByOrderNum',
    method: 'post',
    data,
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    }
  });
}

// 获取我的积分列表查询
export function myIntegralRecord(data) {
  return request({
    url: '/api/visitor/vip/myIntegralRecord',
    method: 'post',
    data,
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    }
  });
}

// 獲取預約須知
export function vipNotice(params) {
  return request({
    url: '/api/visitor/vip/vipNotice',
    method: 'get',
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/member/index.js